import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController } from 'ionic-angular';
import { Configuration } from '../../constants/config';
import { SettingsServiceProvider } from '../../providers/settings-service/settings-service';

/**
 * Generated class for the SettingsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
    selector: 'page-settings',
    templateUrl: 'settings.html',
})
export class SettingsPage {

    par5 : number = 0;
    par6 = "";

    constructor(public navCtrl: NavController, public navParams: NavParams, public toastCtrl: ToastController, public _configuration: Configuration, public settingsService: SettingsServiceProvider) {
        this.load();
    }

    /**
     * @Info Load
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-29
     */
    load(){
        let data = {IdSettings: 0, token: this._configuration.token};
        this.settingsService.read(data)
            .then(data => {
                let response : any = data;
                if (!response.Error){
                    if (response.Success) {
                        this.par5 = response.Content[4].Value;
                        this.par6 = response.Content[5].Value;
                        console.log(response.Content)
                    }else{
                        let toast = this.toastCtrl.create({message: response.Message,position: 'middle',duration: 3000});
                        toast.present();
                    }
                }else{
                    let toast = this.toastCtrl.create({message: response.ErrorMessage,position: 'middle',duration: 3000});
                    toast.present();
                }
            });
    }


    /**
     * @Info Save
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-29
     */
    save(){

        let msg = "";

        if (!msg && !this.par5){
            msg = "Enter the default tax";
        }else{
            if (this.par5 < 0 || this.par5 > 100){
                msg = "Enter a valid percent tax";
            }
        }
        if (!msg && !this.par6){
            msg = "Enter a valid Email Address";
        }

        if (msg) {
            let toast = this.toastCtrl.create({
                message: msg,
                position: 'middle',
                duration: 3000
            });
            toast.present();
        }else{
            this._configuration.defaulTax = this.par5;
            let setting5 = {IdSettings: 5, Value: this.par5};
            let setting6 = {IdSettings: 6, Value: this.par6};
            let settingList = [];
            settingList.push(setting5);
            settingList.push(setting6);
            let data = {Settings: settingList, token: this._configuration.token};
            this.settingsService.update(data)
                .then(data => {
                    let response : any = data;
                    if (!response.Error){
                        if (response.Success) {
                            let toast = this.toastCtrl.create({message: "Successfully applied changes",position: 'middle',duration: 3000});
                            toast.present();
                        }else{
                            let toast = this.toastCtrl.create({message: response.Message,position: 'middle',duration: 3000});
                            toast.present();
                        }
                    }else{
                        let toast = this.toastCtrl.create({message: response.ErrorMessage,position: 'middle',duration: 3000});
                        toast.present();
                    }
                });
        }
    }

}


// WEBPACK FOOTER //
// ./src/pages/settings/settings.ts